<!-- 上证估值 -->
<template>
  <div >
    <VueLoading 
      v-if="isshowloading"
      type="bars" 
      color="#d9544e" 
      :size="{ width: '50px', height: '50px' }"
    ></VueLoading>
    <div> 
    <div class="tabs">
      <div
        v-for="(item, i) in tab.text"
        :ref="'sz' + i"
        :class="['tab', i === tab.index  && 'active']"
        :key=i
        @click="tab.index = i;changetab()"
      >{{item}}</div>
      <div :ltip="szmessage" class="tips"></div>
    </div>

    <div
      v-if="showSHE"
      class="table-wrap"
    >
      <table
        v-if="SHEstimation.PB"
        @click="changetable1"
        :class="{'select-table': istable1select}"
      >
        <tr>
          <td>
            <span class="table-title">上证PE </span>
            <span>(市盈率)</span>
          </td>
        </tr>
        <tr>
          <td>
            当前值：
            <span style="color:#fd4332">{{SHEstimation.PE.realValue | showToFixed}}</span>
          </td>
        </tr>
        <tr>
          <td>
            分位点:
            <div :ltip="markmessage1" class="mark"></div>
            <span> {{(SHEstimation.PE.percentile*100).toFixed(2)}}%</span>
          </td>
          <td>{{szpeQuantile}}</td>
        </tr>
        <tr>
          <td>
            中位值:
            <div :ltip="markmessage2" class="mark"></div>
            <span> {{SHEstimation.PE.median.toFixed(2)}}</span>
          </td>
        </tr>
        <tr>
          <td>
            风险值:
            <div :ltip="markmessage3" class="mark"></div>
            <span> {{SHEstimation.PE.quantile[1].toFixed(2)}}</span>
          </td>
          <td>{{ispedanger?ispedanger:ispedangerprop}}</td>
        </tr>
      </table>
      <table
        @click="changetable2"
        :class="{'select-table': istable2select}"
        v-if="SHEstimation.PB"
      >
        <tr>
          <td>
            <span class="table-title">上证PB </span>
            <span>(市净率)</span>
          </td>
        </tr>
        <tr>
          <td>
            当前值：
            <span style="color:#fd4332">{{SHEstimation.PB.realValue | showToFixed}}</span>
          </td>
        </tr>
        <tr>
          <td>
            分位点:
            <div :ltip="markmessage1" class="mark"></div>
            <span> {{(SHEstimation.PB.percentile*100).toFixed(2)}}%</span>
          </td>
          <td>{{szpbQuantile}}</td>
        </tr>
        <tr>
          <td>
            中位值:
            <div :ltip="markmessage2" class="mark"></div>
            <span> {{SHEstimation.PB.median.toFixed(2)}}</span>
          </td>
        </tr>
        <tr>
          <td>
            风险值:
            <div :ltip="markmessage3" class="mark"></div>
            <span> {{SHEstimation.PB.quantile[1].toFixed(2)}}</span>
          </td>
          <td>{{ispbdanger?ispbdanger:ispbdangerprop}}</td>
        </tr>
      </table>
    </div>
    <div
      v-if="showSZE"
      class="table-wrap"
    >
      <table
        @click="changetable1"
        :class="{'select-table': istable1select}"
        v-if="SZEstimation.PE"
      >
        <tr>
          <td>
            <span class="table-title">深证PE </span>
            <span>(市盈率)</span>
          </td>
        </tr>
        <tr>
          <td>
            当前值：
            <span style="color:#fd4332">{{SZEstimation.PE.realValue | showToFixed}}</span>
          </td>
        </tr>
        <tr>
          <td>
            分位点:
            <div :ltip="markmessage1" class="mark"></div>
            <span> {{(SZEstimation.PE.percentile*100).toFixed(2)}}%</span>
          </td>
          <td>{{szpeQuantile}}</td>
        </tr>
        <tr>
          <td>
            中位值:
            <div :ltip="markmessage2" class="mark"></div>
            <span> {{SZEstimation.PE.median.toFixed(2)}}</span>
          </td>
        </tr>
        <tr>
          <td>
            风险值:
            <div :ltip="markmessage3" class="mark"></div>
            <span> {{SZEstimation.PE.quantile[1].toFixed(2)}}</span>
          </td>
          <td>{{ispedanger?ispedanger:ispedangerprop}}</td>
        </tr>
      </table>
      <table
        @click="changetable2"
        :class="{'select-table': istable2select}"
        v-if="SZEstimation.PB"
      >
        <tr>
          <td>
            <span class="table-title">深证PB </span>
            <span>(市净率)</span>
          </td>
        </tr>
        <tr>
          <td>
            当前值：
            <span style="color:#fd4332">{{SZEstimation.PB.realValue | showToFixed}}</span>
          </td>
        </tr>
        <tr>
          <td>
            分位点:
            <div :ltip="markmessage1" class="mark"></div>
            <span> {{(SZEstimation.PB.percentile*100).toFixed(2)}}%</span>
          </td>
          <td>{{szpbQuantile}}</td>
        </tr>
        <tr>
          <td>
            中位值:
            <div :ltip="markmessage2" class="mark"></div>
            <span> {{SZEstimation.PB.median.toFixed(2)}}</span>
          </td>
        </tr>
        <tr>
          <td>
            风险值:
            <div :ltip="markmessage3" class="mark"></div>
            <span> {{SZEstimation.PB.quantile[1].toFixed(2)}}</span>
          </td>
          <td>{{ispbdanger?ispbdanger:ispbdangerprop}}</td>
        </tr>
      </table>
    </div>
    <div
      v-if="showCZE"
      class="table-wrap"
    >
      <table
        @click="changetable1"
        :class="{'select-table': istable1select}"
        v-if="CYEstimation.PE"
      >
        <tr>
          <td>
            <span class="table-title">创指PE </span>
            <span>(市盈率)</span>
          </td>
        </tr>
        <tr>
          <td>
            当前值：
            <span style="color:#fd4332">{{CYEstimation.PE.realValue | showToFixed}}</span>
          </td>
        </tr>
        <tr>
          <td>
            分位点:
            <div :ltip="markmessage1" class="mark"></div>
            <span> {{(CYEstimation.PE.percentile*100).toFixed(2)}}%</span>
          </td>
          <td>{{szpeQuantile}}</td>
        </tr>
        <tr>
          <td>
            中位值:
            <div :ltip="markmessage2" class="mark"></div>
            <span> {{CYEstimation.PE.median.toFixed(2)}}</span>
          </td>
        </tr>
        <tr>
          <td>
            风险值:
            <div :ltip="markmessage3" class="mark"></div>
            <span> {{CYEstimation.PE.quantile[1].toFixed(2)}}</span>
          </td>
          <td>{{ispedanger?ispedanger:ispedangerprop}}</td>
        </tr>
      </table>
      <table
        @click="changetable2"
        :class="{'select-table': istable2select}"
        v-if="CYEstimation.PB"
      >
        <tr>
          <td>
            <span class="table-title">创指PB </span>
            <span>(市净率)</span>
          </td>
        </tr>
        <tr>
          <td>
            当前值：
            <span style="color:#fd4332">{{CYEstimation.PB.realValue | showToFixed}}</span>
          </td>
        </tr>
        <tr>
          <td>
            分位点:
            <div :ltip="markmessage1" class="mark"></div>
            <span> {{(CYEstimation.PB.percentile*100).toFixed(2)}}%</span>
          </td>
          <td>{{szpbQuantile}}</td>
        </tr>
        <tr>
          <td>
            中位值:
            <div :ltip="markmessage2" class="mark"></div>
            <span> {{CYEstimation.PB.median.toFixed(2)}}</span>
          </td>
        </tr>
        <tr>
          <td>
            风险值:
            <div :ltip="markmessage3" class="mark"></div>
            <span> {{CYEstimation.PB.quantile[1].toFixed(2)}}</span>
          </td>
          <td>{{ispbdanger?ispbdanger:ispbdangerprop}}</td>
        </tr>
      </table>
    </div>

    </div>

    <div class="chart debug" v-show="showSHE">
      <ChartTpl
        key='0'
        v-show="tableindex === 0"
        :elementId='"szValueLine0"'
        ref="szValueLine0"
        :enableResize='true'
        :firstTooltip='true'
        :width='"100%"'
        :height='"248px"'
        :option='line1Option'
        :originData='line1Data'
      ></ChartTpl>
      
      <ChartTpl
        key='1'
        :style="{visibility: tableindex === 1 ? 'visible' : 'hidden'}"
        :elementId='"szValueLine1"'
        ref="szValueLine1"
        :enableResize='true'
        :firstTooltip='true'
        :width='"100%"'
        :height='"248px"'
        :option='line2Option'
        :originData='line1Data'
      ></ChartTpl>
    </div>

    <div class="chart debug" v-show='showSZE'>
      <ChartTpl
        key='2'
        :elementId='"szValueLine2"'
        v-show="tableindex === 2"
        ref="szValueLine2"
        :enableResize='true'
        :firstTooltip='true'
        :width='"100%"'
        :height='"248px"'
        :option='line3Option'
        :originData='line3Data'
      ></ChartTpl>
      <ChartTpl 
        key='3'
        :style="{visibility: tableindex === 3 ? 'visible' : 'hidden'}"
        :elementId='"szValueLine3"'
        ref="szValueLine3"
        :enableResize='true'
        :firstTooltip='true'
        :width='"100%"'
        :height='"248px"'
        :option='line4Option'
        :originData='line3Data'
      ></ChartTpl>
    </div>

    <div class="chart debug" v-show='showCZE'>
      <ChartTpl
        v-show="tableindex === 4"
        key='4'
        :elementId='"szValueLine4"'
        ref="szValueLine4"
        :enableResize='true'
        :firstTooltip='true'
        :width='"100%"'
        :height='"248px"'
        :option='line5Option'
        :originData='line4Data'
      ></ChartTpl>
      <ChartTpl
        key='5'
        :style="{visibility: tableindex === 5 ? 'visible' : 'hidden'}"
        :elementId='"szValueLine5"'
        ref="szValueLine5"
        :enableResize='true'
        :firstTooltip='true'
        :width='"100%"'
        :height='"248px"'
        :option='line6Option'
        :originData='line4Data'
      ></ChartTpl>
    </div>
  </div>
</template>

<script>
import ChartTpl from '@/components/ChartTpl.vue';
import { VueLoading } from 'vue-loading-template';

export default {
  name: "SZValues",
  components: {
    ChartTpl,
    VueLoading
  },
  filters: {
    showToFixed: function (val) {
      return val || val == 0 ? val.toFixed(2) : ''
    }
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    SHEstimation:{     //上证估值数据
      type: Object,
      default: function () {
        return {}
      }
    },
    ispedangerprop: {
      type: String,
      default: ''
    },
    ispbdangerprop: {
      type: String,
      default: ''
    },
    peQuantile: {
      type: String,
      default:''
    },
    pbQuantile: {
      type: String,
      default:''
    },  
    SHValuationSeries: {
      type: Array,
      default:()=>{
        return []
      }
    }
  },
  computed: {

  },
  data() {
    return {
      tab: {
        index: 0,
        text: ["上证估值", "深证估值", "创指估值"]
      },
      tableindex: 0,
      showSHE: true,      
      showSZE: false,
      showCZE: false,
      ispedanger: '',
      ispbdanger: '',
      istable1select: true,
      istable2select: false,
      SZEstimation:{   //深证估值数据
        type: Object,
        default: function () {
          return {}
        }
      },
      CYEstimation:{      //创指估值数据
        type: Object,
        default: function () {
          return {}
        }
      },
      szpeQuantile: '',
      szpbQuantile: '',
      szmessage: '上证估值：上证指数的市盈率（股票价格和每股收益的比例）与市净率（股票价格与每股净资产的比例）',
      line1Option: {},
      line1Data: [],
      line2Option: {},
      // line2Data: [],
      line3Option: {},
      line3Data: [],
      line4Option: {},

      line5Option:{},
      line6Option: {},
      line4Data:[],
      SZValuationSeries: {
        type: Array,
        default: ()=>{
          return []
        }
      },
      CYValuationSeries: {
        type: Array,
        default: ()=>{
          return []
        }
      },
      markmessage1: '当前值在近5年数据中所处的水平',
      markmessage2: '近5年数据的中间值',
      markmessage3: '当前值大于风险值时市场存在风险',
      isshowloading: false,
      flag1: true,
      flag2: true
    };
  },
  watch: {
    CYValuationSeries:{
      handler(newvalue, oldvalue){
        this.initLine4();
      }
    },
    SZValuationSeries:{
      handler(newvalue, oldvalue){
        this.initLine3();
      }
    },
    SHValuationSeries: {
      handler(newvalue, oldvalue){
        this.changetab();
        this.initLine();
      }
    },
    tableindex:{
      handler(newvalue, oldvalue){
        setTimeout(()=>{
          this.$refs['szValueLine'+newvalue].resize();
        })
      }
    }
  },
  mounted() {
    this.report()
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();
    if(!this.SHValuationSeries.length) return;
    this.initLine();
  },
  updated() {  
    LTip.reBind();
  },
  methods: {
    report () {
      let ta = [{ id: 'pcweb_hgdata_shangzgz' }, { id: 'pcweb_hgdata_shenzgz' }, { id: 'pcweb_hgdata_czgz' }]
      for (let i = 0; i < 3; i++) {
        let elm = this.$refs['sz'+i][0]
        TA.logElementClick(elm, ta[i])
      }
    },
    initLine4(){
      this.line5Option = this.$chartConfigs.markLeftToRightArea({
        line1:{
          name: '创业板PE',
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey: 'CY_PE'
        },
        line2:{
          name: '创业板指数',
          lineColor: this.$chartConfigs.projectColors.grey,
          dataKey: 'CY_price'
        },
        markLine: this.CYEstimation.PE.quantile,
        markArea: this.CYEstimation.PE.quantile,
        tooltip: 'getJudge',
        dataZoom:{
          startValue: -650
        }
      });
      this.line6Option = this.$chartConfigs.markLeftToRightArea({
        line1:{
          name: '创业板PB',
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey: 'CY_PB'
        },
        line2:{
          name: '创业板指数',
          lineColor: this.$chartConfigs.projectColors.grey,
          dataKey: 'CY_price'
        },
        markLine: this.CYEstimation.PB.quantile,
        markArea: this.CYEstimation.PB.quantile,
        tooltip: 'getJudge',
        dataZoom:{
          startValue: -650
        }
      });
      this.line4Data = [{
        originData: this.CYValuationSeries
      }]
    },
    initLine3(){
      this.line3Option = this.$chartConfigs.markLeftToRightArea({
        line1:{
          name: '深证PE',
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey: 'SZ_PE'
        },
        line2:{
          name: '深证指数',
          lineColor: this.$chartConfigs.projectColors.grey,
          dataKey: 'SZ_price'
        },
        markLine: this.SZEstimation.PE.quantile,
        markArea: this.SZEstimation.PE.quantile,
        tooltip: 'getJudge',
        dataZoom:{
          startValue: -600
        }
      });
      this.line4Option = this.$chartConfigs.markLeftToRightArea({
        line1:{
          name: '深证PB',
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey: 'SZ_PB'
        },
        line2:{
          name: '深证指数',
          lineColor: this.$chartConfigs.projectColors.grey,
          dataKey: 'SZ_price'
        },
        markLine: this.SZEstimation.PB.quantile,
        markArea: this.SZEstimation.PB.quantile,
        tooltip: 'getJudge',
        dataZoom:{
          startValue: -600
        }
      });
      this.line3Data = [{
        originData: this.SZValuationSeries
      }]
    },
    initLine(){

      this.line1Option = this.$chartConfigs.markLeftToRightArea({
        line1:{
          name: '上证PE',
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey: 'SH_PE'
        },
        line2:{
          name: '上证指数',
          lineColor: this.$chartConfigs.projectColors.grey,
          dataKey: 'SH_price'
        },
        markLine: this.SHEstimation.PE.quantile,
        markArea: this.SHEstimation.PE.quantile,
        dataZoom:{
          startValue: -400
        },
        tooltip: 'getJudge',
      });

      this.line2Option = this.$chartConfigs.markLeftToRightArea({
        line1:{
          name: '上证PB',
          lineColor: this.$chartConfigs.projectColors.blue,
          dataKey: 'SH_PB'
        },
        line2:{
          name: '上证指数',
          lineColor: this.$chartConfigs.projectColors.grey,
          dataKey: 'SH_price'
        },
        markLine: this.SHEstimation.PB.quantile,
        markArea: this.SHEstimation.PB.quantile,
        tooltip: 'getJudge',
        dataZoom:{
          startValue: -400
        }
      });

      this.line1Data = [{
        originData: this.SHValuationSeries
      }]
    },
    getCompareInfo(a, quantile){
      if(a<quantile[0]){
        return {
          danger: '风险低',
          quantile: '较低位置'
        }
      }else if(a>quantile[1]){
        return {
          danger: '有风险',
          quantile: '较高位置'
        }
      }

      return {
        danger: '风险适中',
        quantile: '中等位置'
      }
    },
    isdanger() {
      let info, info2;
      switch(this.tab.index){
        case 0:
          info = this.getCompareInfo(this.SHEstimation.PE.value, this.SHEstimation.PE.quantile);
          this.ispedanger = info.danger;
          this.szpeQuantile = info.quantile;

          info2 = this.getCompareInfo(this.SHEstimation.PB.value, this.SHEstimation.PB.quantile);
          this.ispbdanger = info2.danger;
          this.szpbQuantile = info2.quantile;
          break;
        case 1:
          info = this.getCompareInfo(this.SZEstimation.PE.value, this.SZEstimation.PE.quantile);
          this.ispedanger = info.danger;
          this.szpeQuantile = info.quantile;

          info2 = this.getCompareInfo(this.SZEstimation.PB.value, this.SZEstimation.PB.quantile);
          this.ispbdanger = info2.danger;
          this.szpbQuantile = info2.quantile;
          break;
        case 2:
          info = this.getCompareInfo(this.CYEstimation.PE.value, this.CYEstimation.PE.quantile);
          this.ispedanger = info.danger;
          this.szpeQuantile = info.quantile;

          info2 = this.getCompareInfo(this.CYEstimation.PB.value, this.CYEstimation.PB.quantile);
          this.ispbdanger = info2.danger;
          this.szpbQuantile = info2.quantile;
          break;
      }
    },
    changetab() {
      if(this.tab.index == 0)
      {
        this.showSHE = true;
        this.showSZE = false;
        this.showCZE = false;
        this.tableindex = 0;
        this.isdanger();
        this.szmessage = '上证估值：上证指数的市盈率（股票价格和每股收益的比例）与市净率（股票价格与每股净资产的比例）'
      }
      if(this.tab.index == 1)
      {
        this.showSHE = false;
        this.showSZE = true;
        this.showCZE = false;
        this.tableindex = 2;
        this.szmessage = '深证估值：深证成指的市盈率（股票价格和每股收益的比例）与市净率（股票价格与每股净资产的比例）'
        if(this.flag1 === true)
        {
          this.isshowloading = true;
          this.$api.blockAPI
          .getSZSeries()
          .then(res => {          
            if (res.code === 0) {
              this.isshowloading = false;
              this.SZEstimation = res.data.SZEstimation;            
              this.SZValuationSeries = res.data.SZ_valuation_series;     
              LTip.reBind();
              this.isdanger();
              this.flag1 = false;
            }else{
              console.log('深证估值数据获取异常')
            }
          })
          .catch(e => {});
        }else{
          this.isdanger();
        }

      }
      if(this.tab.index == 2)
      {
        this.showSHE = false;
        this.showSZE = false;
        this.showCZE = true;
        this.tableindex = 4;
        this.szmessage = '创指估值：创业板指的市盈率（股票价格和每股收益的比例）与市净率（股票价格与每股净资产的比例）'

        if(this.flag2 === true)
        {
          this.isshowloading = true;
          this.$api.blockAPI
          .getCYSeries()
          .then(res => {
            if (res.code === 0) {
              this.isshowloading = false;
              this.CYEstimation = res.data.CYEstimation;
              this.CYValuationSeries = res.data.CY_valuation_series;
              this.isdanger();
              LTip.reBind();
              this.flag2 = false;
            }else{
              console.log('创指估值数据获取异常')
            }
          })
          .catch(e => {});
        }else{
          this.isdanger();
        }

        
      }
      this.istable1select = true;
      this.istable2select = false;
    },
    changetable1() {
      this.istable1select = true;
      this.istable2select = false;
      switch(this.tab.index) {
        case 0:
          this.tableindex = 0;
          break;
        case 1:
          this.tableindex = 2;
          break;
        case 2:
          this.tableindex = 4;  
      }

    },
    changetable2() {
      this.istable2select = true;
      this.istable1select = false;
      switch(this.tab.index) {
        case 0:
          this.tableindex = 1;
          break;
        case 1:
          this.tableindex = 3;
          break;
        case 2:
          this.tableindex = 5;  
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  width: 225px;
  height: 24px;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  align-items: center;
  .tab {
    width: 33%;
    border: 1px solid #3b3c41;
    text-align: center;
    color: #616266;
    cursor: pointer;
  }
}
.table-wrap table {
  border: 1px solid rgb(28, 29, 33);
}
.table-wrap {
  display: flex;
  justify-content: space-between;
  padding: 14px 0 7px;
  width: 97%;
  table {
    font-size: 12px;
    width: 48%;
    height: 110px;
    padding-left: 10px;
    td {
      color: #a6a9ae;
    }
    span {
      color: #a6a9ae;
    }
  }
  .select-table {
    background: #1b3859;
    border: 1px solid #0096ff;
  }
  .table-title {
    color: #ffffff;
  }
}
.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:28px;
  height: 16px;
}
.mark {
  position: relative;
  display: inline-block;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/mark.png') no-repeat;
  vertical-align: middle;
  width: 17px;
  height: 11px;
}
.tab.active {
  background: #3b3c41;
  color: #fff;
  cursor: default;
}

.chart {
  // flex: 1 1 auto;
}
.vue-loading {
  position: absolute;
  top: 50%;
  left: 40%;
  z-index: 9999;
}
</style>

